import React from 'react';
import { useConfig } from '../../ConfigContext';
import { fontFamilies } from '../../../glassConsts';

export default function SocialsStats({ color, font }) {
  const { size, socials, general } = useConfig();

  const pluginUrl = window.GBCONF ? window.GBCONF.pluginUrl : '';
  const socialsPics = pluginUrl + 'igpics.png';

  let mobileCoefficient = 0.8;
  if (window.innerWidth < 500) mobileCoefficient = 1;

  return (
    <div
      style={{
        marginTop: (size.height / 48) * mobileCoefficient,
      }}
    >
      <div id="socials_icons">
        <div
          style={{
            color: general.color,
            fontFamily: fontFamilies[general.font],
          }}
        >
          <div id="likes" className="soc_stats">
            {socials.isLiked ? (
              <svg
                fill="#FF0000"
                width={(size.height / 30) * mobileCoefficient}
                height={(size.height / 30) * mobileCoefficient}
                viewBox="0 0 122.88 107.39"
              >
                <path d="M60.83,17.18c8-8.35,13.62-15.57,26-17C110-2.46,131.27,21.26,119.57,44.61c-3.33,6.65-10.11,14.56-17.61,22.32-8.23,8.52-17.34,16.87-23.72,23.2l-17.4,17.26L46.46,93.55C29.16,76.89,1,55.92,0,29.94-.63,11.74,13.73.08,30.25.29c14.76.2,21,7.54,30.58,16.89Z" />
              </svg>
            ) : (
              <svg
                fill={general.color}
                width={(size.height / 30) * mobileCoefficient}
                height={(size.height / 30) * mobileCoefficient}
                viewBox="0 0 90 90"
              >
                <path d="M 45 85.465 L 7.098 47.563 C 2.521 42.986 0 36.9 0 30.426 c 0 -6.473 2.521 -12.559 7.099 -17.136 c 4.577 -4.577 10.663 -7.098 17.136 -7.098 s 12.559 2.521 17.137 7.098 L 45 16.919 l 3.63 -3.629 c 4.576 -4.577 10.662 -7.098 17.136 -7.098 s 12.56 2.521 17.136 7.099 v 0 c 0 0 0 0 0 0 C 87.479 17.867 90 23.953 90 30.426 c 0 6.474 -2.521 12.56 -7.099 17.136 L 45 85.465 z M 24.234 14.192 c -4.336 0 -8.413 1.688 -11.479 4.755 C 9.689 22.013 8 26.09 8 30.426 c 0 4.336 1.689 8.414 4.755 11.479 L 45 74.15 l 32.244 -32.244 C 80.312 38.84 82 34.763 82 30.426 c 0 -4.336 -1.688 -8.413 -4.755 -11.479 v 0 c -3.066 -3.066 -7.144 -4.755 -11.479 -4.755 s -8.413 1.688 -11.479 4.755 L 45 28.233 l -9.286 -9.286 C 32.647 15.881 28.571 14.192 24.234 14.192 z" />
              </svg>
            )}
            <span
              style={{
                fontSize: (size.height / 44) * mobileCoefficient,
              }}
            >
              {socials.useCustomStats && socials.likes > 0 ? socials.likes : ''}
            </span>
          </div>
          <div id="coments" className="soc_stats">
            <svg
              width={(size.height / 30) * mobileCoefficient}
              height={(size.height / 30) * mobileCoefficient}
              fill={general.color}
              viewBox="0 0 122.97 122.88"
            >
              <path d="M61.44,0a61.46,61.46,0,0,1,54.91,89l6.44,25.74a5.83,5.83,0,0,1-7.25,7L91.62,115A61.43,61.43,0,1,1,61.44,0ZM96.63,26.25a49.78,49.78,0,1,0-9,77.52A5.83,5.83,0,0,1,92.4,103L109,107.77l-4.5-18a5.86,5.86,0,0,1,.51-4.34,49.06,49.06,0,0,0,4.62-11.58,50,50,0,0,0-13-47.62Z" />
            </svg>
            <span
              style={{
                fontSize: (size.height / 44) * mobileCoefficient,
              }}
            >
              {socials.useCustomStats && socials.comments > 0
                ? socials.comments
                : ''}
            </span>
          </div>

          <div id="shares" className="soc_stats">
            <svg
              width={size.height / 30}
              height={size.height / 30}
              fill={general.color}
              viewBox="0 0 122.88 108.3"
            >
              <path d="M96.14,12.47l-76.71-1.1,28.3,27.85L96.14,12.47ZM53.27,49l9.88,39.17L102.1,22,53.27,49ZM117,1.6a5.59,5.59,0,0,1,4.9,8.75L66.06,105.21a5.6,5.6,0,0,1-10.44-1.15L41.74,49,1.67,9.57A5.59,5.59,0,0,1,5.65,0L117,1.6Z" />
            </svg>
            <span
              style={{
                fontSize: (size.height / 44) * mobileCoefficient,
              }}
            >
              {socials.useCustomStats && socials.shares > 0
                ? socials.shares
                : ''}
            </span>
          </div>
        </div>
        <svg
          width={size.height / 30}
          height={size.height / 30}
          viewBox="0 0 459 511.87"
          fill={general.color}
        >
          <path
            fillRule="nonzero"
            d="M32.256 0h394.488c8.895 0 16.963 3.629 22.795 9.462C455.371 15.294 459 23.394 459 32.256v455.929c0 13.074-10.611 23.685-23.686 23.685-7.022 0-13.341-3.07-17.683-7.93L230.124 330.422 39.692 505.576c-9.599 8.838-24.56 8.214-33.398-1.385a23.513 23.513 0 01-6.237-16.006L0 32.256C0 23.459 3.629 15.391 9.461 9.55l.089-.088C15.415 3.621 23.467 0 32.256 0zm379.373 47.371H47.371v386.914l166.746-153.364c8.992-8.198 22.933-8.319 32.013.089l165.499 153.146V47.371z"
          />
        </svg>
      </div>

      <div id="socials_box">
        <div
          className="socials_name"
          style={{
            color: general.color,
            fontFamily: fontFamilies[general.font],
            fontSize: (size.height / 50) * mobileCoefficient,
          }}
        >
          {socials.name.length < 1 ? 'Název účtu' : socials.name}
        </div>
        <div
          className="socials_description"
          style={{
            color: general.color,
            fontFamily: fontFamilies[general.font],
            fontSize: (size.height / 51) * mobileCoefficient,
          }}
        >
          {socials.description.length < 1 ? 'Popisek' : socials.description}
        </div>
      </div>
      <div
        id="socials_liked_by"
        style={{
          color: general.color,
        }}
      >
        <img
          src={socialsPics}
          alt="Skleněná deska"
          className="socials_pic"
          draggable={false}
          style={{
            width: size.width / 15,
          }}
        />
        <div
          style={{
            color: general.color,
            fontFamily: fontFamilies[general.font],
            fontSize: (size.height / 51) * mobileCoefficient,
          }}
        >
          <span>To se líbí </span>
          <span>{socials.likesTag.length < 1 ? '____' : socials.likesTag}</span>
          <span> a dalším </span>
          <span>
            {socials.likesOthersCount.length < 1
              ? '____'
              : socials.likesOthersCount}
          </span>
        </div>
      </div>
    </div>
  );
}
